var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShoppingBasketSad1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 13.75L14.25 3.75",
    stroke: "#9FA3A6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33 13.75L26.75 3.75",
    stroke: "#9FA3A6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.06 36.25H8.93996C8.39865 36.2402 7.87653 36.0478 7.45818 35.7042C7.03983 35.3606 6.74975 34.8857 6.63496 34.3567L3.07162 16.8567C2.97622 16.4974 2.96302 16.1213 3.03299 15.7562C3.10296 15.3912 3.25431 15.0466 3.47579 14.7481C3.69727 14.4496 3.98318 14.2049 4.31226 14.0321C4.64135 13.8593 5.00515 13.7628 5.37662 13.75H35.6233C35.9948 13.7628 36.3586 13.8593 36.6876 14.0321C37.0167 14.2049 37.3026 14.4496 37.5241 14.7481C37.7456 15.0466 37.8969 15.3912 37.9669 15.7562C38.0369 16.1213 38.0237 16.4974 37.9283 16.8567L34.365 34.3567C34.2502 34.8857 33.9601 35.3606 33.5417 35.7042C33.1234 36.0478 32.6013 36.2402 32.06 36.25Z",
    stroke: "#9FA3A6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 19.1948C15.6236 19.1948 15.7445 19.2315 15.8472 19.3002C15.95 19.3688 16.0301 19.4664 16.0774 19.5806C16.1247 19.6949 16.1371 19.8205 16.113 19.9418C16.0889 20.063 16.0294 20.1744 15.9419 20.2618C15.8545 20.3492 15.7432 20.4087 15.6219 20.4328C15.5007 20.4569 15.375 20.4446 15.2608 20.3972C15.1466 20.3499 15.049 20.2698 14.9803 20.1671C14.9117 20.0643 14.875 19.9434 14.875 19.8198C14.875 19.6541 14.9408 19.4951 15.0581 19.3779C15.1753 19.2607 15.3342 19.1948 15.5 19.1948Z",
    stroke: "#9FA3A6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 19.1948C25.6236 19.1948 25.7445 19.2315 25.8472 19.3002C25.95 19.3688 26.0301 19.4664 26.0774 19.5806C26.1247 19.6949 26.1371 19.8205 26.113 19.9418C26.0889 20.063 26.0294 20.1744 25.9419 20.2618C25.8545 20.3492 25.7432 20.4087 25.6219 20.4328C25.5007 20.4569 25.375 20.4446 25.2608 20.3972C25.1466 20.3499 25.049 20.2698 24.9803 20.1671C24.9117 20.0643 24.875 19.9434 24.875 19.8198C24.875 19.6541 24.9408 19.4951 25.0581 19.3779C25.1753 19.2607 25.3342 19.1948 25.5 19.1948Z",
    stroke: "#9FA3A6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5167 31.2481C26.7455 30.0945 25.7018 29.1488 24.4779 28.4947C23.254 27.8407 21.8877 27.4985 20.5001 27.4985C19.1124 27.4985 17.7461 27.8407 16.5222 28.4947C15.2983 29.1488 14.2546 30.0945 13.4834 31.2481",
    stroke: "#9FA3A6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingBasketSad1);
export default __webpack_public_path__ + "static/media/shopping-basket-sad-1.f3daba541e2cf95133fde44230e2b69d.svg";
export { ForwardRef as ReactComponent };